module.exports = __webpack_public_path__ + "img/toLearnpic_yinpin.d31037eb.png";